var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "mandate-conformity-banner" },
    [
      _c("img", {
        attrs: {
          src: "/ressources/logged/img/illustrations/settings-warning.svg",
          alt: ""
        }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "mandate-conformity-banner__content" }, [
        _c(
          "h2",
          {
            staticClass:
              "mandate-conformity-banner__title typographies-paragraph-large-bold"
          },
          [_vm._v("\n            " + _vm._s(_vm.title) + "\n        ")]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "mandate-conformity-banner__description typographies-paragraph-medium-regular"
          },
          [_vm._v("\n            " + _vm._s(_vm.description) + "\n        ")]
        )
      ]),
      _vm._v(" "),
      _vm.hasAction
        ? _c(
            "CompassButton",
            _vm._b(
              {
                staticClass: "mandate-conformity-banner__action",
                attrs: { type: "tertiary-contrast" },
                on: { click: _vm.actionEvent }
              },
              "CompassButton",
              _vm.actionProps,
              false
            )
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }